import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc76d42c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white text-h5 font-weight-bold" }, "Your password has been changed.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white text-body-1" }, "Please log in to proceed.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EmailPrompt = _resolveComponent("EmailPrompt")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_ActivationPrompt = _resolveComponent("ActivationPrompt")!
  const _component_ResendPrompt = _resolveComponent("ResendPrompt")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fill-height overflow-x-hidden", _ctx.smAndDown ? 'background-mob' : 'background'])
  }, [
    _createVNode(_component_v_row, { class: "relative z99 fill-height" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "absolute centered"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "start",
              class: "relative"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "auto",
                  class: "absolute"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.landscapeLogoSrc,
                      cover: "",
                      "max-width": _ctx.smAndDown ? 200 : 350,
                      class: "py-2 mx-2 float-right"
                    }, null, 8, ["src", "max-width"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_stepper, {
              modelValue: _ctx.activeStep,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeStep) = $event)),
              flat: "",
              class: "fill-height",
              id: "login-stepper"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_window, {
                  "model-value": _ctx.activeStep,
                  class: "fill-height"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_stepper_window_item, {
                      value: _ctx.ResetSteps.EmailPrompt,
                      class: "fill-height"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "fill-height",
                          justify: "center",
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_EmailPrompt, {
                                  onCheckEmail: _cache[0] || (_cache[0] = ($event: any) => {_ctx.username = $event; _ctx.checkUser(_ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username);}),
                                  "query-username": _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                  error: _ctx.error,
                                  onClearError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = ''))
                                }, null, 8, ["query-username", "error"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_v_stepper_window_item, {
                      value: _ctx.ResetSteps.ActivationPrompt,
                      class: "fill-height"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "fill-height",
                          justify: "center",
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ActivationPrompt, {
                                  info: _ctx.info,
                                  username: _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                  "query-code": _ctx.$route.query.code ? _ctx.$route.query.code : null,
                                  onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.Success)),
                                  "onGoTo:resend": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.Resend))
                                }, null, 8, ["info", "username", "query-code"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_v_stepper_window_item, {
                      value: _ctx.ResetSteps.Resend,
                      class: "fill-height"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "fill-height",
                          justify: "center",
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ResendPrompt, {
                                  "onGoTo:email": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeStep = _ctx.ResetSteps.EmailPrompt)),
                                  username: _ctx.$route.query.username ? _ctx.$route.query.username : _ctx.username,
                                  activating: false
                                }, null, 8, ["username"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_v_stepper_window_item, {
                      value: _ctx.ResetSteps.Success,
                      class: "fill-height"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "fill-height",
                          justify: "center",
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  justify: "center",
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "5",
                                      class: "pa-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, {
                                          color: "primary",
                                          class: "px-4 py-6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              "no-gutters": "",
                                              align: "center",
                                              justify: "center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_1
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "12",
                                                  class: "my-6 text-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_2
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      width: "95",
                                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({name: 'login', query: {username: _ctx.username}}))),
                                                      color: "secondary"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Log in")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}